import Client from 'shopify-buy';

// Initializing a client
const client = Client.buildClient({
    domain: 'rff-rice.myshopify.com',
    storefrontAccessToken: '6ce70471c687199cb3d86bcd80ab8512'
});

/**
 * Fetch a Variant's Cart ID (different from Shopify ID) for direct updating
 *
 * @param checkoutID
 * @param variantID
 * @param quantity
 * @param callback
 */
function getVariantCheckoutId(checkoutID, variantID, quantity = 0, callback) {
    client.checkout.fetch(checkoutID).then((checkout) => {
        for (var i = 0; i < (checkout.lineItems).length; i++) {
            // Search for Shopify Variant ID match to get Line Item ID for updating/deleting
            if ((checkout.lineItems)[i].variant.id === variantID) {
                callback((checkout.lineItems)[i].id, quantity)
            }
        }
    });
}

// ------------------------------------------------------------------------------------------------------------------ //

/**
 * Add Item
 *
 * @param checkoutID
 * @param variantID
 * @param quantity
 * @returns {number}
 */
window.cartAddLineItem = function (checkoutID, variantID, quantity) {
    if (checkoutID === null) {
        client.checkout.create().then((checkout) => {
            Livewire.dispatchTo('cart', 'updateCheckout', { checkout: checkout });

            // Re-call self w/ Checkout ID
            cartAddLineItem(checkout.id, variantID, quantity)
        });

        return 0;
    }

    const lineItemsToAdd = [{
        variantId: variantID,
        quantity: parseInt(quantity)
    }];

    // Add an item to the checkout
    client.checkout.addLineItems(checkoutID, lineItemsToAdd).then((checkout) => {
        Livewire.dispatchTo('cart', 'updateCheckout', { checkout: checkout });
    });

    return 1;
}

/**
 *
 * Add Multiple Items
 *
 * @param checkoutID
 * @param variants
 * @returns {number}
 */
window.cartAddLineItems = function (checkoutID, variants) {
    if (checkoutID === null) {
        client.checkout.create().then((checkout) => {
            Livewire.dispatchTo('cart', 'updateCheckout', { checkout: checkout });

            // Re-call self w/ Checkout ID
            cartAddLineItems(checkout.id, variants)
        });

        return 0;
    }

    // Add an item to the checkout
    client.checkout.addLineItems(checkoutID, variants).then((checkout) => {
        Livewire.dispatchTo('cart', 'updateCheckout', { checkout: checkout });
    });

    return 1;
}

/**
 * Update Item
 *
 * @param checkoutID
 * @param variantID
 * @param quantity
 * @returns {number}
 */
window.cartUpdateLineItem = function (checkoutID, variantID, quantity) {

    getVariantCheckoutId(checkoutID, variantID, quantity, function (variant_id, quantity) {
        const lineItemsToUpdate = [{
            id: variant_id,
            quantity: parseInt(quantity)
        }];

        // Update the line item on the checkout (change the quantity or variant)
        client.checkout.updateLineItems(checkoutID, lineItemsToUpdate).then((checkout) => {
            Livewire.dispatchTo('cart', 'updateCheckout', { checkout: checkout });
        });
    })

    return 1;
}

/**
 * Remove Item
 *
 * @param checkoutID
 * @param variantID
 * @returns {number}
 */
window.cartRemoveLineItem = function (checkoutID, variantID) {
    // Remove an item from the checkout
    getVariantCheckoutId(checkoutID, variantID, 0, function (variant_id, quantity) {
        client.checkout.removeLineItems(checkoutID, [variant_id]).then((checkout) => {
            Livewire.dispatchTo('cart', 'updateCheckout', { checkout: checkout });
        });
    })

    return 1;
}

/**
 * Remove Multiple Items.
 *
 * @param checkoutID
 * @param variants
 * @returns {number}
 */
window.cartRemoveLineItems = function (checkoutID, variants) {

    client.checkout.fetch(checkoutID).then((checkout) => {
        let removals = [];
        for (var i = 0; i < (checkout.lineItems).length; i++) {
            // Search for Shopify Variant ID match to get Line Item ID for updating/deleting
            if (variants.includes((checkout.lineItems)[i].variant.id)) {
                removals.push((checkout.lineItems)[i].id);
            }
        }

        client.checkout.removeLineItems(checkoutID, removals).then((checkout) => {
            Livewire.dispatchTo('cart', 'updateCheckout', {checkout: checkout});
        });
    });

    return 1;
}

/**
 * Adds a customer note to the Cart
 *
 * @param checkoutID
 * @param note
 */
window.cartAddNote = function (checkoutID, note) {
    const input = {
        note: note,
        customAttributes: [{key: "Customer Note", value: note}]
    };

    client.checkout.updateAttributes(checkoutID, input).then((checkout) => {
        Livewire.dispatchTo('cart', 'updateCheckout', { checkout: checkout });
    });

    return 1;
}
